// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_resource.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { AppResourceSearch } from "./app_resource";
import type { SearchAppResourceTypesRollupResponse } from "./app_resource";
import type { SearchAppResourceTypesRollupRequest } from "./app_resource";
import type { SearchAppResourceGrantsResponse } from "./app_resource";
import type { SearchAppResourceGrantsRequest } from "./app_resource";
import type { GetAppResourceGrantsSearchTermsResponse } from "./app_resource";
import type { GetAppResourceGrantsSearchTermsRequest } from "./app_resource";
import type { HighRiskRolesAndGrantsEntitlementsResponse } from "./app_resource";
import type { HighRiskRolesAndGrantsEntitlementsRequest } from "./app_resource";
import type { HighRiskRolesAndGrantsCountResponse } from "./app_resource";
import type { HighRiskRolesAndGrantsCountRequest } from "./app_resource";
import type { HighRiskRolesAndGrantsResponse } from "./app_resource";
import type { HighRiskRolesAndGrantsRequest } from "./app_resource";
import type { SearchAppResourcesWithDeactivatedOwnerResponse } from "./app_resource";
import type { SearchAppResourcesWithDeactivatedOwnerRequest } from "./app_resource";
import type { SearchAppResourceTypeTraitsRollupResponse } from "./app_resource";
import type { SearchAppResourceTypeTraitsRollupRequest } from "./app_resource";
import type { SearchAppResourceRollupResponse } from "./app_resource";
import type { SearchAppResourceRollupRequest } from "./app_resource";
import type { SearchAppResourcesResponse } from "./app_resource";
import type { SearchAppResourcesRequest } from "./app_resource";
import type { SearchAppResourceTypesResponse } from "./app_resource";
import type { SearchAppResourceTypesRequest } from "./app_resource";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AppResourceService } from "./app_resource";
import type { DeleteManuallyManagedEntitlementResponse } from "./app_resource";
import type { DeleteManuallyManagedEntitlementRequest } from "./app_resource";
import type { DeleteManuallyManagedAppResourceResponse } from "./app_resource";
import type { DeleteManuallyManagedAppResourceRequest } from "./app_resource";
import type { CreateManuallyManagedAppResourceResponse } from "./app_resource";
import type { CreateManuallyManagedAppResourceRequest } from "./app_resource";
import type { CreateManuallyManagedResourceResponse } from "./app_resource";
import type { CreateManuallyManagedResourceRequest } from "./app_resource";
import type { AppResourceServiceUpdateResponse } from "./app_resource";
import type { AppResourceServiceUpdateRequest } from "./app_resource";
import type { AppResourceServiceListResponse } from "./app_resource";
import type { AppResourceServiceListRequest } from "./app_resource";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { AppResourceServiceGetResponse } from "./app_resource";
import type { AppResourceServiceGetRequest } from "./app_resource";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.app.v1.AppResourceService
 */
export interface IAppResourceServiceClient {
    /**
     * @generated from protobuf rpc: Get(c1.api.app.v1.AppResourceServiceGetRequest) returns (c1.api.app.v1.AppResourceServiceGetResponse);
     */
    get(input: AppResourceServiceGetRequest, options?: RpcOptions): UnaryCall<AppResourceServiceGetRequest, AppResourceServiceGetResponse>;
    /**
     * @generated from protobuf rpc: List(c1.api.app.v1.AppResourceServiceListRequest) returns (c1.api.app.v1.AppResourceServiceListResponse);
     */
    list(input: AppResourceServiceListRequest, options?: RpcOptions): UnaryCall<AppResourceServiceListRequest, AppResourceServiceListResponse>;
    /**
     * @generated from protobuf rpc: Update(c1.api.app.v1.AppResourceServiceUpdateRequest) returns (c1.api.app.v1.AppResourceServiceUpdateResponse);
     */
    update(input: AppResourceServiceUpdateRequest, options?: RpcOptions): UnaryCall<AppResourceServiceUpdateRequest, AppResourceServiceUpdateResponse>;
    /**
     * @generated from protobuf rpc: CreateManuallyManagedResource(c1.api.app.v1.CreateManuallyManagedResourceRequest) returns (c1.api.app.v1.CreateManuallyManagedResourceResponse);
     */
    createManuallyManagedResource(input: CreateManuallyManagedResourceRequest, options?: RpcOptions): UnaryCall<CreateManuallyManagedResourceRequest, CreateManuallyManagedResourceResponse>;
    /**
     * @generated from protobuf rpc: CreateManuallyManagedAppResource(c1.api.app.v1.CreateManuallyManagedAppResourceRequest) returns (c1.api.app.v1.CreateManuallyManagedAppResourceResponse);
     */
    createManuallyManagedAppResource(input: CreateManuallyManagedAppResourceRequest, options?: RpcOptions): UnaryCall<CreateManuallyManagedAppResourceRequest, CreateManuallyManagedAppResourceResponse>;
    /**
     * @generated from protobuf rpc: DeleteManuallyManagedAppResource(c1.api.app.v1.DeleteManuallyManagedAppResourceRequest) returns (c1.api.app.v1.DeleteManuallyManagedAppResourceResponse);
     */
    deleteManuallyManagedAppResource(input: DeleteManuallyManagedAppResourceRequest, options?: RpcOptions): UnaryCall<DeleteManuallyManagedAppResourceRequest, DeleteManuallyManagedAppResourceResponse>;
    /**
     * @generated from protobuf rpc: DeleteManuallyManagedEntitlement(c1.api.app.v1.DeleteManuallyManagedEntitlementRequest) returns (c1.api.app.v1.DeleteManuallyManagedEntitlementResponse);
     */
    deleteManuallyManagedEntitlement(input: DeleteManuallyManagedEntitlementRequest, options?: RpcOptions): UnaryCall<DeleteManuallyManagedEntitlementRequest, DeleteManuallyManagedEntitlementResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppResourceService
 */
export class AppResourceServiceClient implements IAppResourceServiceClient, ServiceInfo {
    typeName = AppResourceService.typeName;
    methods = AppResourceService.methods;
    options = AppResourceService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Get(c1.api.app.v1.AppResourceServiceGetRequest) returns (c1.api.app.v1.AppResourceServiceGetResponse);
     */
    get(input: AppResourceServiceGetRequest, options?: RpcOptions): UnaryCall<AppResourceServiceGetRequest, AppResourceServiceGetResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppResourceServiceGetRequest, AppResourceServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: List(c1.api.app.v1.AppResourceServiceListRequest) returns (c1.api.app.v1.AppResourceServiceListResponse);
     */
    list(input: AppResourceServiceListRequest, options?: RpcOptions): UnaryCall<AppResourceServiceListRequest, AppResourceServiceListResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppResourceServiceListRequest, AppResourceServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Update(c1.api.app.v1.AppResourceServiceUpdateRequest) returns (c1.api.app.v1.AppResourceServiceUpdateResponse);
     */
    update(input: AppResourceServiceUpdateRequest, options?: RpcOptions): UnaryCall<AppResourceServiceUpdateRequest, AppResourceServiceUpdateResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppResourceServiceUpdateRequest, AppResourceServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateManuallyManagedResource(c1.api.app.v1.CreateManuallyManagedResourceRequest) returns (c1.api.app.v1.CreateManuallyManagedResourceResponse);
     */
    createManuallyManagedResource(input: CreateManuallyManagedResourceRequest, options?: RpcOptions): UnaryCall<CreateManuallyManagedResourceRequest, CreateManuallyManagedResourceResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateManuallyManagedResourceRequest, CreateManuallyManagedResourceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateManuallyManagedAppResource(c1.api.app.v1.CreateManuallyManagedAppResourceRequest) returns (c1.api.app.v1.CreateManuallyManagedAppResourceResponse);
     */
    createManuallyManagedAppResource(input: CreateManuallyManagedAppResourceRequest, options?: RpcOptions): UnaryCall<CreateManuallyManagedAppResourceRequest, CreateManuallyManagedAppResourceResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateManuallyManagedAppResourceRequest, CreateManuallyManagedAppResourceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteManuallyManagedAppResource(c1.api.app.v1.DeleteManuallyManagedAppResourceRequest) returns (c1.api.app.v1.DeleteManuallyManagedAppResourceResponse);
     */
    deleteManuallyManagedAppResource(input: DeleteManuallyManagedAppResourceRequest, options?: RpcOptions): UnaryCall<DeleteManuallyManagedAppResourceRequest, DeleteManuallyManagedAppResourceResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteManuallyManagedAppResourceRequest, DeleteManuallyManagedAppResourceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteManuallyManagedEntitlement(c1.api.app.v1.DeleteManuallyManagedEntitlementRequest) returns (c1.api.app.v1.DeleteManuallyManagedEntitlementResponse);
     */
    deleteManuallyManagedEntitlement(input: DeleteManuallyManagedEntitlementRequest, options?: RpcOptions): UnaryCall<DeleteManuallyManagedEntitlementRequest, DeleteManuallyManagedEntitlementResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteManuallyManagedEntitlementRequest, DeleteManuallyManagedEntitlementResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.app.v1.AppResourceSearch
 */
export interface IAppResourceSearchClient {
    /**
     * Search app resources based on filters specified in the request body.
     *
     * @generated from protobuf rpc: SearchAppResourceTypes(c1.api.app.v1.SearchAppResourceTypesRequest) returns (c1.api.app.v1.SearchAppResourceTypesResponse);
     */
    searchAppResourceTypes(input: SearchAppResourceTypesRequest, options?: RpcOptions): UnaryCall<SearchAppResourceTypesRequest, SearchAppResourceTypesResponse>;
    /**
     * @generated from protobuf rpc: SearchAppResources(c1.api.app.v1.SearchAppResourcesRequest) returns (c1.api.app.v1.SearchAppResourcesResponse);
     */
    searchAppResources(input: SearchAppResourcesRequest, options?: RpcOptions): UnaryCall<SearchAppResourcesRequest, SearchAppResourcesResponse>;
    /**
     * @generated from protobuf rpc: SearchAppResourcesRollup(c1.api.app.v1.SearchAppResourceRollupRequest) returns (c1.api.app.v1.SearchAppResourceRollupResponse);
     */
    searchAppResourcesRollup(input: SearchAppResourceRollupRequest, options?: RpcOptions): UnaryCall<SearchAppResourceRollupRequest, SearchAppResourceRollupResponse>;
    /**
     * @generated from protobuf rpc: SearchAppResourceTypeTraitsRollup(c1.api.app.v1.SearchAppResourceTypeTraitsRollupRequest) returns (c1.api.app.v1.SearchAppResourceTypeTraitsRollupResponse);
     */
    searchAppResourceTypeTraitsRollup(input: SearchAppResourceTypeTraitsRollupRequest, options?: RpcOptions): UnaryCall<SearchAppResourceTypeTraitsRollupRequest, SearchAppResourceTypeTraitsRollupResponse>;
    /**
     * @generated from protobuf rpc: SearchAppResourcesWithDeactivatedOwner(c1.api.app.v1.SearchAppResourcesWithDeactivatedOwnerRequest) returns (c1.api.app.v1.SearchAppResourcesWithDeactivatedOwnerResponse);
     */
    searchAppResourcesWithDeactivatedOwner(input: SearchAppResourcesWithDeactivatedOwnerRequest, options?: RpcOptions): UnaryCall<SearchAppResourcesWithDeactivatedOwnerRequest, SearchAppResourcesWithDeactivatedOwnerResponse>;
    /**
     * @generated from protobuf rpc: HighRiskRolesAndGrants(c1.api.app.v1.HighRiskRolesAndGrantsRequest) returns (c1.api.app.v1.HighRiskRolesAndGrantsResponse);
     */
    highRiskRolesAndGrants(input: HighRiskRolesAndGrantsRequest, options?: RpcOptions): UnaryCall<HighRiskRolesAndGrantsRequest, HighRiskRolesAndGrantsResponse>;
    /**
     * @generated from protobuf rpc: HighRiskRolesAndGrantsCount(c1.api.app.v1.HighRiskRolesAndGrantsCountRequest) returns (c1.api.app.v1.HighRiskRolesAndGrantsCountResponse);
     */
    highRiskRolesAndGrantsCount(input: HighRiskRolesAndGrantsCountRequest, options?: RpcOptions): UnaryCall<HighRiskRolesAndGrantsCountRequest, HighRiskRolesAndGrantsCountResponse>;
    /**
     * @generated from protobuf rpc: HighRiskRolesAndGrantsEntitlements(c1.api.app.v1.HighRiskRolesAndGrantsEntitlementsRequest) returns (c1.api.app.v1.HighRiskRolesAndGrantsEntitlementsResponse);
     */
    highRiskRolesAndGrantsEntitlements(input: HighRiskRolesAndGrantsEntitlementsRequest, options?: RpcOptions): UnaryCall<HighRiskRolesAndGrantsEntitlementsRequest, HighRiskRolesAndGrantsEntitlementsResponse>;
    /**
     * @generated from protobuf rpc: GetAppResourceGrantsSearchTerms(c1.api.app.v1.GetAppResourceGrantsSearchTermsRequest) returns (c1.api.app.v1.GetAppResourceGrantsSearchTermsResponse);
     */
    getAppResourceGrantsSearchTerms(input: GetAppResourceGrantsSearchTermsRequest, options?: RpcOptions): UnaryCall<GetAppResourceGrantsSearchTermsRequest, GetAppResourceGrantsSearchTermsResponse>;
    /**
     * @generated from protobuf rpc: SearchAppResourceGrants(c1.api.app.v1.SearchAppResourceGrantsRequest) returns (c1.api.app.v1.SearchAppResourceGrantsResponse);
     */
    searchAppResourceGrants(input: SearchAppResourceGrantsRequest, options?: RpcOptions): UnaryCall<SearchAppResourceGrantsRequest, SearchAppResourceGrantsResponse>;
    /**
     * @generated from protobuf rpc: SearchAppResourceTypesRollup(c1.api.app.v1.SearchAppResourceTypesRollupRequest) returns (c1.api.app.v1.SearchAppResourceTypesRollupResponse);
     */
    searchAppResourceTypesRollup(input: SearchAppResourceTypesRollupRequest, options?: RpcOptions): UnaryCall<SearchAppResourceTypesRollupRequest, SearchAppResourceTypesRollupResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppResourceSearch
 */
export class AppResourceSearchClient implements IAppResourceSearchClient, ServiceInfo {
    typeName = AppResourceSearch.typeName;
    methods = AppResourceSearch.methods;
    options = AppResourceSearch.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Search app resources based on filters specified in the request body.
     *
     * @generated from protobuf rpc: SearchAppResourceTypes(c1.api.app.v1.SearchAppResourceTypesRequest) returns (c1.api.app.v1.SearchAppResourceTypesResponse);
     */
    searchAppResourceTypes(input: SearchAppResourceTypesRequest, options?: RpcOptions): UnaryCall<SearchAppResourceTypesRequest, SearchAppResourceTypesResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppResourceTypesRequest, SearchAppResourceTypesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppResources(c1.api.app.v1.SearchAppResourcesRequest) returns (c1.api.app.v1.SearchAppResourcesResponse);
     */
    searchAppResources(input: SearchAppResourcesRequest, options?: RpcOptions): UnaryCall<SearchAppResourcesRequest, SearchAppResourcesResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppResourcesRequest, SearchAppResourcesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppResourcesRollup(c1.api.app.v1.SearchAppResourceRollupRequest) returns (c1.api.app.v1.SearchAppResourceRollupResponse);
     */
    searchAppResourcesRollup(input: SearchAppResourceRollupRequest, options?: RpcOptions): UnaryCall<SearchAppResourceRollupRequest, SearchAppResourceRollupResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppResourceRollupRequest, SearchAppResourceRollupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppResourceTypeTraitsRollup(c1.api.app.v1.SearchAppResourceTypeTraitsRollupRequest) returns (c1.api.app.v1.SearchAppResourceTypeTraitsRollupResponse);
     */
    searchAppResourceTypeTraitsRollup(input: SearchAppResourceTypeTraitsRollupRequest, options?: RpcOptions): UnaryCall<SearchAppResourceTypeTraitsRollupRequest, SearchAppResourceTypeTraitsRollupResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppResourceTypeTraitsRollupRequest, SearchAppResourceTypeTraitsRollupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppResourcesWithDeactivatedOwner(c1.api.app.v1.SearchAppResourcesWithDeactivatedOwnerRequest) returns (c1.api.app.v1.SearchAppResourcesWithDeactivatedOwnerResponse);
     */
    searchAppResourcesWithDeactivatedOwner(input: SearchAppResourcesWithDeactivatedOwnerRequest, options?: RpcOptions): UnaryCall<SearchAppResourcesWithDeactivatedOwnerRequest, SearchAppResourcesWithDeactivatedOwnerResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppResourcesWithDeactivatedOwnerRequest, SearchAppResourcesWithDeactivatedOwnerResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: HighRiskRolesAndGrants(c1.api.app.v1.HighRiskRolesAndGrantsRequest) returns (c1.api.app.v1.HighRiskRolesAndGrantsResponse);
     */
    highRiskRolesAndGrants(input: HighRiskRolesAndGrantsRequest, options?: RpcOptions): UnaryCall<HighRiskRolesAndGrantsRequest, HighRiskRolesAndGrantsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<HighRiskRolesAndGrantsRequest, HighRiskRolesAndGrantsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: HighRiskRolesAndGrantsCount(c1.api.app.v1.HighRiskRolesAndGrantsCountRequest) returns (c1.api.app.v1.HighRiskRolesAndGrantsCountResponse);
     */
    highRiskRolesAndGrantsCount(input: HighRiskRolesAndGrantsCountRequest, options?: RpcOptions): UnaryCall<HighRiskRolesAndGrantsCountRequest, HighRiskRolesAndGrantsCountResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<HighRiskRolesAndGrantsCountRequest, HighRiskRolesAndGrantsCountResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: HighRiskRolesAndGrantsEntitlements(c1.api.app.v1.HighRiskRolesAndGrantsEntitlementsRequest) returns (c1.api.app.v1.HighRiskRolesAndGrantsEntitlementsResponse);
     */
    highRiskRolesAndGrantsEntitlements(input: HighRiskRolesAndGrantsEntitlementsRequest, options?: RpcOptions): UnaryCall<HighRiskRolesAndGrantsEntitlementsRequest, HighRiskRolesAndGrantsEntitlementsResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<HighRiskRolesAndGrantsEntitlementsRequest, HighRiskRolesAndGrantsEntitlementsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAppResourceGrantsSearchTerms(c1.api.app.v1.GetAppResourceGrantsSearchTermsRequest) returns (c1.api.app.v1.GetAppResourceGrantsSearchTermsResponse);
     */
    getAppResourceGrantsSearchTerms(input: GetAppResourceGrantsSearchTermsRequest, options?: RpcOptions): UnaryCall<GetAppResourceGrantsSearchTermsRequest, GetAppResourceGrantsSearchTermsResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAppResourceGrantsSearchTermsRequest, GetAppResourceGrantsSearchTermsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppResourceGrants(c1.api.app.v1.SearchAppResourceGrantsRequest) returns (c1.api.app.v1.SearchAppResourceGrantsResponse);
     */
    searchAppResourceGrants(input: SearchAppResourceGrantsRequest, options?: RpcOptions): UnaryCall<SearchAppResourceGrantsRequest, SearchAppResourceGrantsResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppResourceGrantsRequest, SearchAppResourceGrantsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppResourceTypesRollup(c1.api.app.v1.SearchAppResourceTypesRollupRequest) returns (c1.api.app.v1.SearchAppResourceTypesRollupResponse);
     */
    searchAppResourceTypesRollup(input: SearchAppResourceTypesRollupRequest, options?: RpcOptions): UnaryCall<SearchAppResourceTypesRollupRequest, SearchAppResourceTypesRollupResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppResourceTypesRollupRequest, SearchAppResourceTypesRollupResponse>("unary", this._transport, method, opt, input);
    }
}
